export const users = {

  web: {
    subdomain: window.location.host,
    locale: window.location.pathname.split("/")[2]
  },

  async me() {
    const json = await fetch('/api/v2/users/me.json')
    return json;
  }
}